// substance/filters.ts
import type { SubstanceRow, SubstanceUsage, SubstanceType } from "./_model";
export interface SubstanceFilters {
  type: SubstanceType[]; status: string[]; comp: ("chrom" | "formula" | "none")[];
  stock: "in" | "out" | "noinfo" | null; family: string[]; tag: string[];
}
export const defaultFilters = (): SubstanceFilters => ({ type: [], status: [], comp: [], stock: null, family: [], tag: [] });
export function applyFilters(
  items: SubstanceRow[],
  { search, usageTab, filters }: { search: string; usageTab: "all" | SubstanceUsage; filters: SubstanceFilters },
): SubstanceRow[] {
  const q = (search || "").trim().toLowerCase();
  return items.filter((s) => {
    if (usageTab !== "all" && !s.usage.includes(usageTab)) return false;
    if (filters.type.length && !filters.type.includes(s.type)) return false;
    if (filters.status.length && !filters.status.includes(s.status)) return false;
    if (filters.family.length && !filters.family.includes(s.family)) return false;
    if (filters.tag.length && !filters.tag.some((t) => s.tags.includes(t))) return false;
    if (filters.comp.length) {
      const hasChrom = s.chrom > 0, hasForm = !!s.formula;
      const none = !hasChrom && !hasForm && s.type === "mixture";
      if (!filters.comp.some((c) => (c === "chrom" && hasChrom) || (c === "formula" && hasForm) || (c === "none" && none))) return false;
    }
    if (filters.stock === "in" && !s.stock?.inStock) return false;
    if (filters.stock === "out" && !(s.stock && !s.stock.inStock)) return false;
    if (filters.stock === "noinfo" && s.stock) return false;
    if (q) {
      const hay = [s.name, s.code, ...s.cas, ...s.fema, ...s.ec, ...s.internal,
                   s.stock?.supplier, s.stock?.lot, s.stock?.catalog, ...s.tags].filter(Boolean).join(" ").toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}
